import '../../Styles/Projekte.css';
import React, { memo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Button, Modal, Form, Spinner } from 'react-bootstrap';
import useTextTemplates from '../../hooks/TextTemplateHooks/useTextTemplates';

function TextTemplateComponent() {
    const { templates, loading, error, createTemplate, editTemplate, deleteTemplate } = useTextTemplates();
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [active, setActive] = useState(false);
    const [templateHeadline, setTemplateHeadline] = useState('');
    const [templateText, setTemplateText] = useState('');
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [textTemplateID, setTextTemplateID] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [templateType, setTemplateType] = useState('');
    if (error) {
        console.log(error);
    }

    const handleOpenCreateModal = () => {
        setActive(false);
        setTemplateHeadline('');
        setTemplateText('');
        setTextTemplateID(Math.floor(Math.random() * 1000000000000000000).toString());
        setShowCreateModal(true);
    };

    const handleCloseCreateModal = () => {
        setShowCreateModal(false);
        setShowEditModal(false);
    };

    const handleOpenEditModal = (template) => {
        // alert(JSON.stringify(template))
        setSelectedTemplate(template);
        setActive(template.active);
        setTemplateHeadline(template.templateHeadline);
        setTemplateText(template.templateText);
        setShowEditModal(true);
        setTemplateType(template.textType)
        setTextTemplateID(template.textTemplateID);
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setShowCreateModal(false);
    };

    const handleOpenDeleteModal = (template) => {
        setSelectedTemplate(template);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const handleCreateSubmit = async (event) => {
        event.preventDefault();
        handleCloseCreateModal();
        await createTemplate({ templateHeadline, templateText, active, textTemplateID, templateType });
    };

    const handleEditSubmit = async (event) => {
        event.preventDefault();
        handleCloseEditModal();
        await editTemplate({ templateHeadline, templateText, active, textTemplateID, templateType });
    };

    const handleDeleteSubmit = async () => {
        handleCloseDeleteModal();
        await deleteTemplate(selectedTemplate.textTemplateID);
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1); // Reset to the first page on new search
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // Reset to the first page on items per page change
    };

    const filteredTemplates = templates.filter(template =>
        template.templateHeadline.toLowerCase().includes(searchQuery.toLowerCase()) ||
        template.templateText.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const paginatedTemplates = filteredTemplates.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const totalPages = Math.ceil(filteredTemplates.length / itemsPerPage);

    return (
        <div className='container handwai-dark' style={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%' }}>

                <Form.Control
                    type="text"
                    placeholder="Suchen"
                    value={searchQuery}
                    onChange={handleSearch}
                    style={{ maxWidth: '300px' }}
                />
                <Form.Control
                    as="select"
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                    style={{ maxWidth: '100px' }}
                >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                </Form.Control>
                <Button className='handwai-btn-create' onClick={handleOpenCreateModal}>
                    <FontAwesomeIcon icon={faPlus} /> &emsp; Neues Text Template
                </Button>
            </div>

            {loading ? (
                <div className="loading-indicator" style={{
                    padding: 20,
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                }}>
                    <Spinner style={{ color: '#fff' }} animation="border" />
                </div>
            ) : (
                <>
                    <table id='projektTable' className='table'>
                        <thead>
                            <tr>
                                <th>Status</th>
                                <th>Titel</th>
                                <th>Typ</th>
                                <th>Beschreibung</th>
                                <th className='centerStyle'>Aktion</th>
                            </tr>
                        </thead>
                        <tbody className='handwai-text-label-normal'>
                            {paginatedTemplates.map((template) => (
                                <tr key={template.textTemplateID}>
                                    <td>{template.active ? 'Aktiv' : 'Inaktiv'}</td>
                                    <td>{template.templateHeadline}</td>
                                    <td>{template.textType}</td>
                                    <td>{template.templateText}</td>
                                    <td className='centerStyle'>
                                        <Button
                                            onClick={() => handleOpenEditModal(template)}
                                            className='handwai-btn-create'>Bearbeiten</Button>
                                        {' '}
                                        <Button
                                            onClick={() => handleOpenDeleteModal(template)}
                                            className='handwai-btn-logout'>Löschen</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className='handwai-text-label-normal pagination' style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 30,
                    }}>
                        <Button
                            className='handwai-btn-create'
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(currentPage - 1)}
                        >
                            Vorherige
                        </Button>
                        {[...Array(totalPages)].map((_, index) => (
                            <Button
                                key={index + 1}
                                className='handwai-btn-create'
                                onClick={() => setCurrentPage(index + 1)}
                                active={currentPage === index + 1}
                            >
                                {index + 1}
                            </Button>
                        ))}
                        <Button
                            className='handwai-btn-create'
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(currentPage + 1)}
                        >
                            Nächste
                        </Button>
                    </div>
                </>
            )}

            {/* Create Modal */}
            <Modal style={{ padding: 20 }} show={showCreateModal} onHide={handleCloseCreateModal}>
                <Form className='handwai-dark' style={{ padding: 10 }} onSubmit={handleCreateSubmit}>
                    <Modal.Header style={{ borderWidth: 0 }} className='handwai-dark'>
                        <Modal.Title className='handwai-text-label-main'>Neues Vorlage</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='handwai-dark'>
                        <Form.Group controlId='formActive'>
                            <Form.Check
                                type='checkbox'
                                label='Aktiv'
                                className='handwai-text-label-normal'
                                checked={active}
                                onChange={(e) => setActive(e.target.checked)}
                            />
                        </Form.Group>
                        <Form.Group controlId='formTemplateHeadline'>
                            <Form.Label className='handwai-text-label-normal'>Vorlage Titel</Form.Label>
                            <Form.Control
                                className='handwai-input'
                                type='text'
                                placeholder='Geben Sie den Titel der Textvorlage ein'
                                value={templateHeadline}
                                onChange={(e) => setTemplateHeadline(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group controlId='formTemplateContent'>
                            <Form.Label className='handwai-text-label-normal'>Beschreibung</Form.Label>
                            <Form.Control
                                className='handwai-input'
                                as='textarea'
                                rows={3}
                                placeholder='Geben Sie eine Beschreibung der Textvorlage ein'
                                value={templateText}
                                onChange={(e) => setTemplateText(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group controlId='formTemplateType'>
                            <Form.Label className='handwai-text-label-normal'>Vorlage Typ</Form.Label>
                            <Form.Control
                                as='select'
                                className='handwai-input'
                                value={templateType}
                                onChange={(e) => setTemplateType(e.target.value)}
                            >
                                <option value=''>Wählen Sie einen Typ</option>
                                <option value='Stundenlohn-Anmeldung'>Stundenlohn-Anmeldung</option>
                                <option value='Störung'>Störung</option>
                                <option value='Behinderung-Anmeldung'>Behinderung-Anmeldung</option>
                            </Form.Control>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer style={{ borderWidth: 0 }} className='handwai-dark'>
                        <Button className='handwai-btn-logout' onClick={handleCloseCreateModal}>
                            Abbrechen
                        </Button>
                        <Button className='handwai-btn-login' variant='primary' type='submit'>
                            Erstellen
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Edit Modal */}
            <Modal style={{ padding: 20 }} show={showEditModal} onHide={handleCloseEditModal}>
                <Form className='handwai-dark' style={{ padding: 10 }} onSubmit={handleEditSubmit}>
                    <Modal.Header style={{ borderWidth: 0 }} className='handwai-dark'>
                        <Modal.Title className='handwai-text-label-main'>Vorlage Bearbeiten</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='handwai-dark'>
                        <Form.Group controlId='formActive'>
                            <Form.Check
                                type='checkbox'
                                label='Aktiv'
                                className='handwai-text-label-normal'
                                checked={active}
                                onChange={(e) => setActive(e.target.checked)}
                            />
                        </Form.Group>
                        <Form.Group controlId='formTemplateHeadline'>
                            <Form.Label className='handwai-text-label-normal'>Vorlage Titel</Form.Label>
                            <Form.Control
                                className='handwai-input'
                                type='text'
                                placeholder='Geben Sie den Titel der Textvorlage ein'
                                value={templateHeadline}
                                onChange={(e) => setTemplateHeadline(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group controlId='formTemplateContent'>
                            <Form.Label className='handwai-text-label-normal'>Beschreibung</Form.Label>
                            <Form.Control
                                className='handwai-input'
                                as='textarea'
                                rows={3}
                                placeholder='Geben Sie eine Beschreibung der Textvorlage ein'
                                value={templateText}
                                onChange={(e) => setTemplateText(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group controlId='formTemplateType'>
                            <Form.Label className='handwai-text-label-normal'>Vorlage Typ</Form.Label>
                            <Form.Control
                                as='select'
                                className=''
                                value={templateType}
                                defaultValue={templateType || ''}
                                onChange={(e) => setTemplateType(e.target.value)}
                            >
                                <option value=''>Wählen Sie einen Typ</option>
                                <option value='Stundenlohn-Anmeldung'>Stundenlohn-Anmeldung</option>
                                <option value='Störung'>Störung</option>
                                <option value='Behinderung-Anmeldung'>Behinderung-Anmeldung</option>
                            </Form.Control>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer style={{ borderWidth: 0 }} className='handwai-dark'>
                        <Button className='handwai-btn-logout' onClick={handleCloseEditModal}>
                            Abbrechen
                        </Button>
                        <Button className='handwai-btn-login' variant='primary' type='submit'>
                            Speichern
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Delete Modal */}
            <Modal style={{ padding: 20 }} show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header style={{ borderWidth: 0 }} className='handwai-dark'>
                    <Modal.Title className='handwai-text-label-main'>Vorlage Löschen</Modal.Title>
                </Modal.Header>
                <Modal.Body className='handwai-dark'>
                    <p className='handwai-text-label-normal'>
                        Sind Sie sicher, dass Sie die Vorlage <strong>{selectedTemplate?.templateHeadline}</strong> löschen möchten?
                    </p>
                </Modal.Body>
                <Modal.Footer style={{ borderWidth: 0 }} className='handwai-dark'>
                    <Button className='handwai-btn-logout' onClick={handleCloseDeleteModal}>
                        Abbrechen
                    </Button>
                    <Button className='handwai-btn-login' variant='primary' onClick={handleDeleteSubmit}>
                        Löschen
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default memo(TextTemplateComponent);
